import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 13: Your Guiding Compass</h1>
          <p className="white"><b>How to connect with your inner voice to find your path</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Put both of your hands on your heart and breathe deeply and slowly.
            </li>
            <li>Think back over your life. What is something you were always drawn towards? What interested you or resonated with you on a deeper level? What grabbed at your curiosity?
            </li>
            <li>Ask yourself, “What are my unique gifts? What am I meant to do in this world? How can I use my gifts to serve and contribute?”
            </li>
            <li>Listen.
            </li>
            <li>Now, there’s a good chance that nothing happened, and you just heard some hyper-critical crickets. Let it go. Repeat the above steps over again and be patient and compassionate with yourself.
            </li>
            <li>If that still doesn’t work, ask yourself, “If my inner voice were speaking up for me right now from a place of love and wisdom, what would it say?”
            </li>
            <li>Another way to tap into your inner wisdom is to imagine that you had the opportunity to speak with your future much older, much wiser self. Ask for your future self’s advice. If you face silence, reframe the question to ‘if they had to give me advice what would they say?’
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter13.js